import { useEffect } from 'react';

declare global {
  interface Window {
    $crisp?: unknown[];
    CRISP_WEBSITE_ID?: string;
  }
}

// Balão de suporte do Crisp (workspace "tynk | suporte"). O id do site não é
// segredo: viaja no HTML de toda página, como o de um pixel.
export const CRISP_WEBSITE_ID = '888c9594-90bd-4368-84dc-538923229371';
const CRISP_SCRIPT_SRC = 'https://client.crisp.chat/l.js';
const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1']);

// Em desenvolvimento local nada é baixado e nenhuma conversa nasce no Crisp.
export const isCrispHostname = (hostname: string): boolean =>
  !LOCAL_HOSTNAMES.has(hostname);

function loadCrisp() {
  if (
    window.$crisp ||
    document.querySelector(`script[src="${CRISP_SCRIPT_SRC}"]`)
  ) {
    return;
  }
  window.$crisp = [];
  window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;
  const script = document.createElement('script');
  script.src = CRISP_SCRIPT_SRC;
  script.async = true;
  document.head.append(script);
}

export function Crisp() {
  useEffect(() => {
    if (!isCrispHostname(window.location.hostname)) return;
    loadCrisp();
  }, []);

  return null;
}
